import type { ComponentProps } from 'react';
import type { Share } from '@frameio/graphql-client/generated';
import type { useToast } from '@frameio/vapor';
import { ToastAlert } from '@frameio/vapor';
import TEXT from './generated/TEXT/renderShareAccessToast';

TEXT.DEFINE({
  /** The title of a toast that is shown when the access to a share is updated successfully */
  success: ({ name }: { name?: string }) =>
    `Access to "${name}" has been updated`,
  /** The title of a toast that is shown when an error occurs during an attempted update */
  error: ({ name }: { name?: string }) =>
    `Failed to update access${name ? ` for ${name}` : ''}`,
});

const TOAST_OPTIONS = {
  duration: 4000,
};

type UpdateShareAccessToastProps = {
  shareName?: Share['name'];
  variant: Extract<
    ComponentProps<typeof ToastAlert>['variant'],
    'error' | 'success'
  >;
};

export function renderShareAccessToast(
  addToast: ReturnType<typeof useToast>['addToast'],
  { variant, shareName }: UpdateShareAccessToastProps
) {
  addToast(
    (closeToast, toastCloseLabel) => (
      <ToastAlert
        closeLabel={toastCloseLabel}
        onRequestClose={closeToast}
        title={TEXT[variant]({ name: shareName })?.toString() as string}
        variant={variant}
      />
    ),
    TOAST_OPTIONS
  );
}
